import { render } from "./RoomSocket.vue?vue&type=template&id=38b42089"
import script from "./RoomSocket.vue?vue&type=script&lang=js"
export * from "./RoomSocket.vue?vue&type=script&lang=js"
script.render = render

export default script